import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonNavLink, IonIcon, IonInput, IonItem, IonPage, IonSpinner, IonText, IonToolbar, useIonViewWillEnter, useIonViewWillLeave, IonTitle } from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useState } from "react";
import { Contacts, PhoneType } from "@capacitor-community/contacts";
import { setUserContacts } from '../../services/redux/slices/user-contacts/user-contacts';
import { useAppDispatch, useAppSelector } from "../../services/redux/hook";

const TopupNewContactPage: React.FC = () => {

    const nav = document.querySelector("ion-nav");
    const { t, i18n } = useTranslation();
    const [isSpinner, setIsSpinner] = useState(false);
    const dispatch = useAppDispatch();
    const existingContacts = useAppSelector((state) => state.userContacts);

    const {
        handleSubmit,
        register,
        getValues,
        formState: { errors }
    } = useForm({ defaultValues: { contact_name: '', contact_phone_number: '' } });

    const onSubmit = async () => {

        const data = getValues();

        await createNewContact(data.contact_name, data.contact_phone_number)
        nav?.pop();
    }

    const createNewContact = async (givenName: string, phoneNumber: string) => {

        setIsSpinner(true);

        try {

            const res = await Contacts.createContact({
                contact: {
                    name: {
                        given: givenName,
                    },

                    phones: [
                        {
                            type: PhoneType.Mobile,
                            label: 'mobile',
                            number: phoneNumber,
                        },
                    ],

                },
            });

            

            if (res.contactId) {
                // Dispatch to update the Redux store with the new contact
                dispatch(
                    setUserContacts(
                        [...existingContacts,
                        {
                            contactId: res.contactId,
                            name: { 
                                display: givenName,
                                given: givenName,
                                middle: '',
                                family: '',
                                prefix: '',
                                suffix: ''
                            },
                            phones: [{ number: phoneNumber, type: PhoneType.Mobile }]
                        }]));
            }
        } catch (error) {

        } finally {
            setIsSpinner(false);
        }


    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border ">
                <IonToolbar>

                    <IonNavLink routerDirection={'back'}>
                        <IonButtons slot='start'>
                            <IonButton color={'primary'}>
                                <IonIcon slot='start' icon={arrowBackOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonNavLink>
                    <IonTitle> {t('topups.new_contact.page.HEADER')}</IonTitle>

                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }}>
                    <div className="ion-padding">
                        <IonInput
                            className="ion-text-start"
                            fill="outline"
                            mode="md"
                            label={t('topups.new_contact.page.NAME_INPUT') as string}
                            clearOnEdit={true}
                            labelPlacement="floating"
                            {...register('contact_name', {
                                required: `${t('topups.new_contact.page.name.ERROR_REQUIRED')}`,
                                pattern: {
                                    value: /^[^\n0-9_!¡?÷?¿\/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/i,
                                    message: `${t('topups.new_contact.page.CONTACT_NAME_INVALID')}`
                                }
                            })} />
                        <div className="ion-padding">
                            <ErrorMessage
                                errors={errors}
                                name="contact_name"
                                as={<div style={{ color: 'red' }} />}
                            />
                        </div>
                    </div>

                    <div className="ion-padding" >
                        <IonInput
                            className="ion-text-start"
                            mode="md"
                            fill="outline"
                            label={t('topups.new_contact.page.NAME_INPUT_PHONE') as string}
                            clearOnEdit={true}
                            inputMode='tel'
                            labelPlacement="floating"
                            {...register('contact_phone_number', {
                                required: `${t('topups.new_contact.page.contact_phone.ERROR_REQUIRED')}`,
                                pattern: {
                                    value: /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g,
                                    message: `${t('topups.new_contact.page.contact_phone_INVALID')}`
                                }
                            })} />

                    </div>
                    <div>
                        <ErrorMessage
                            errors={errors}
                            name="contact_phone_number"
                            as={<div style={{ color: 'red' }} />}
                        />

                    </div>
                </form>
            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        color={'primary'}
                        type="submit"
                        expand="block"
                        id='pageFooterButton'
                        onClick={handleSubmit(onSubmit)}>
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            : t('topups.new_contact.page.BTN_ADD')}

                    </IonButton>
                </IonToolbar>
            </IonFooter>

        </IonPage>
    )
}

export default TopupNewContactPage